<template>
  <div class="bg-white mt-3 p-2">
    <div class="list-group list-group-flush" v-for="(notification, index) in notifications" :key="index">
      <router-link class="list-group-item list-group-item-action border-bottom" :to="getViewerTo(notification)">
        <div class="d-flex justify-content-start">
          <div class="d-flex publication-date">
            {{ $moment(notification.publication_from).format('yyyy/MM/DD') }}
            <badge v-if="notification.is_new" class="bg-danger" text="NEW" />
          </div>
          <span class="d-flex">{{ notification.title }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Badge from '@/views/atoms/Badge'

export default {
  name: "NotificationList",
  components: {
    Badge,
  },
  inject: [
    '$moment'
  ],
  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getViewerTo(notification) {
      return {name: 'NotificationViewer', params: {id: notification.id}};
    },
  },
}
</script>

<style scoped>
.publication-date {
  width: 9.5rem;
}
</style>
